import(/* webpackMode: "eager", webpackExports: ["EditorAppBar"] */ "/usr/src/app/frontend/src/app/(editor)/@appBar/n/[noteId]/editor-app-bar.tsx");
